import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { formatDate } from '@angular/common';
import { SharedConstants } from '@constants';

@Injectable({
    providedIn: 'root'
})

@Pipe({
  name: 'formatDate',
  standalone: true
})
export class FormatDatePipe implements PipeTransform {

    stringToDate(value: string, inputFormat: string): Date {
        let year = 2014;
        let month = 1;
        let day = 1;
        let hours = 0;
        let minutes = 0;
        let seconds = 0;
        let miliSeconds = 0;

        switch (inputFormat) {
            case SharedConstants.dateOutputFormatHm:   // 'dd/MM/yyyy HH:mm'
                day = parseInt(value.slice(0, 2));
                month = parseInt(value.slice(3, 5));
                year = parseInt(value.slice(6, 10));
                hours = parseInt(value.slice(11, 13));
                minutes = parseInt(value.slice(14, 16));
                break;
            case SharedConstants.dateOutputFormat:     //'dd/MM/yyyy':
                day = parseInt(value.slice(0, 2));
                month = parseInt(value.slice(3, 5));
                year = parseInt(value.slice(6, 10));
                break;
            case SharedConstants.dateAPIFormat: // 'yyyy-MM-dd'
                year = parseInt(value.slice(0, 4));
                month = parseInt(value.slice(5, 7));
                day = parseInt(value.slice(8, 10));
                break;
            default:
                throw new Error('Invalid date format');
        }

        return new Date(year, month - 1, day, hours, minutes, seconds, miliSeconds);
    }

    transform(text: string, inputFormat: string, outputFormat: string, locale: string = 'en-UK'): string {
        if (!text || text === '') {
            return '';
        }

        const date = this.stringToDate(text, inputFormat);
        const formattedDate = formatDate(date, outputFormat, locale);
        //const formattedDate = moment(date).format(outputFormat);
        return formattedDate;
    }
}

/*
  Example of use:
    <div>
    <p>{{ '25/12/2024 14:30' | formatDate:dateInputFormat:dateOutputFormat }}</p>
    <p>{{ '25/12/2024 14:30' | formatDate:'dd/MM/yyyy':'dd MMM YYYY' }}</p>
  </div>
        */
